import {
  CONNECT_API_PREFIX,
  ConnectDeviceSummarySchema,
  ConnectOwnerOptionsSchema,
} from "@rakazo/contracts";
import { readBoundedJsonResponse } from "@rakazo/core";

/** Session-authenticated, same-origin management only. Device credentials never enter the web UI. */
export async function connectRequest(
  path: "list" | "options" | "claim" | "policy" | "pause" | "revoke" | "power",
  body: Record<string, unknown>,
  signal?: AbortSignal,
) {
  const response = await fetch(`${CONNECT_API_PREFIX}/owner/${path}`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
    signal: signal
      ? AbortSignal.any([signal, AbortSignal.timeout(15_000)])
      : AbortSignal.timeout(15_000),
  });
  if (!response.ok)
    throw new Error(
      response.status === 404
        ? "Connect is not enabled on this server."
        : "Could not update devices. Check your access and try again.",
    );
  const data = await readBoundedJsonResponse<unknown>(response, 512 * 1024);
  if (path === "list") return ConnectDeviceSummarySchema.array().parse(data);
  if (path === "options") return ConnectOwnerOptionsSchema.parse(data);
  return data;
}
